import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// if (environment.production) {
//   const node = document.createElement('script');
//   node.src = './adyen-scripts/adyen-live.js';
//   node.type = 'text/javascript';
//   node.charset = 'utf-8';
//   document.getElementsByTagName('body')[0].appendChild(node);
//   enableProdMode();
// } else {
//   const node = document.createElement('script');
//   node.src = './adyen-scripts/adyen-test.js';
//   node.type = 'text/javascript';
//   node.charset = 'utf-8';
//   document.getElementsByTagName('body')[0].appendChild(node);
// }



document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(loaded => loaded)
    .catch(err => console.log(err));
});